export const LOCALE_PT_BR = "pt-br";
export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "HH:mm";
export const DATE_FORMAT_ISO = "YYYY-MM-DD";